
import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Self, ViewChild } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Search } from 'ace-builds-internal/search';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Subscription } from 'rxjs';
import { HTTPService } from 'src/app/services/http.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { LayoutVersionService } from 'src/app/services/layout-version.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ThemeService } from 'src/app/services/theme.service';
import { UploadServices } from 'src/app/services/upload.services';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { SearchProperties } from 'src/app/system-utils/search-input-new/search-input-new.component';
import { DateUtils } from 'src/app/system-utils/utils/DateUtils';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { Validacoes } from 'src/app/system-utils/utils/validators/validacao';

@Component({
    selector: 'app-user-form-config',
    templateUrl: './user-form-config.component.html',
    styleUrls: ['./user-form-config.component.scss'],
    providers: [HTTPService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class UserFormConfigComponent implements OnInit {

  @ViewChild("fileInput") fileInput: ElementRef;
  files  = [];  
  formGroup:UntypedFormGroup;
  senhaGroup:UntypedFormGroup;
  layoutOption:{key:string,value:string}[] =
    [
      {key:"dark",value:"Escuro"},
      {key:"light",value:"Claro"},
      {key:"light_modern",value:"Claro Moderno"},
      {key:"vault",value:"VAULT"}
  ];

  simnao:{key:string,value:string}[] = [{key:"S",value:"Sim"},{key:"N",value:"Não"}];
  image =  this.sanitizer.bypassSecurityTrustUrl( "assets/image/no-image-icon-round.png");
  hide = true;
  hideConfirmacao = true;
  sub:Subscription;
  sub2:Subscription;
  sub3:Subscription;
  isLoading = false;
  readonly passwordMinLength = 12;

  

  constructor( public datepipe: DatePipe, 
    public ThemeService:ThemeService, 
    @Self() private http:HTTPService, 
    private sanitizer: DomSanitizer,
    private uploadService: UploadServices, 
    private uas:UserAuthenticationServices, 
    private formBuilder:UntypedFormBuilder,
    private snackBar:SnackbarService,
    public dialogRef:NzModalRef,
    public ls:LanguageServices,
    @Inject(NZ_MODAL_DATA) public dataNz,
    private layoutVersionService:LayoutVersionService,
    private cd:ChangeDetectorRef) {

        this.formGroup = this.formBuilder.group({
          username: new UntypedFormControl({value:'',disabled:true}),
          iduser: new UntypedFormControl({value:'',disabled:true}),
          nome: new UntypedFormControl(''),
          layout: new UntypedFormControl(''),
          useravatar: new UntypedFormControl(''),
          timeout: new UntypedFormControl(''),
          usetab:new FormControl<string>('S'),
          iddashboard:new FormControl('')
        })

        this.senhaGroup = new UntypedFormGroup({
          password: new UntypedFormControl('', 
          
          Validators.compose([
            Validators.required,
            Validacoes.patternValidator(/\d/, { hasNumber: true }),
            Validacoes.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
            Validacoes.patternValidator(/[a-z]/, { hasSmallCase: true }),
            Validacoes.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
            Validacoes.patternValidator(/[$&+,:;=?@#|'<>.^*()%!-]/, { hasSpecialCharacter: true }),
            Validators.minLength(this.passwordMinLength)
          ])
          ),
          oldPassword: new UntypedFormControl('',Validators.compose([Validators.required,Validators.minLength(4)]))
          ,

          confirmacao: new UntypedFormControl('',Validators.compose([Validators.required,Validators.minLength(4)]))
       },Validators.compose([Validacoes.SenhasCombinam]));
       
       
  }

  

  ngOnInit() {
      
  }

  searchDashboard:SearchProperties ={
          entityName:'Mktpdashboard',
          fields:{keyField:'INTERNALID', valueField:'NAME'},
          placeholder:this.ls.instant("systemView.dashboard"),
          showKey:true,
          size:'default'        
  }
  

  ngOnDestroy(){
      if ( this.sub !=null){this.sub.unsubscribe();}
      if ( this.sub2 !=null){this.sub2.unsubscribe();}
      if ( this.sub3 !=null){this.sub3.unsubscribe();}
  }

  ngAfterViewInit(){
      this.loadData();
  }

  showPreview(event) {
    
    let file:Blob = (event.target as HTMLInputElement).files[0];
    let fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    
    fileReader.onload = ((array)=>{
      
      let TYPED_ARRAY = new Uint8Array(array.target.result as ArrayBuffer);
      //const STRING_CHAR = String.fromCharCode.apply(null, TYPED_ARRAY);

      var binary = '';
      var bytes = new Uint8Array( TYPED_ARRAY );
      var len = bytes.byteLength;
      for (var i = 0; i < len; i++) {
          binary += String.fromCharCode( bytes[ i ] );
      }
      
      let base64String = btoa(binary);

      this.formGroup.get('useravatar').patchValue(base64String);
      this.formGroup.get('useravatar').updateValueAndValidity()
      
      let objectURL = 'data:image/png;base64,' + base64String;
      this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
      this.cd.detectChanges();
    })
  }

  salvar(){

    
    if ( (this.senhaGroup.valid && !this.senhaGroup.pristine && this.confirmacao.value != null ) || this.senhaGroup.pristine){
      this.isLoading = true;
      let ob = {
        entityName: 'Mktpuser',
        LAYOUT: this.formGroup.get("layout").value,
        USERAVATAR: this.formGroup.get("useravatar").value,
        NOME: this.formGroup.get("nome").value,
        IDUSER: this.formGroup.get("iduser").value,
        TIMEOUT: this.formGroup.get('timeout').value,
        USETAB: this.formGroup.get('usetab').value,
        IDDASHBOARD: this.formGroup.get('iddashboard').value?.key||null
      }

      let alterouSenha = false;

      if ( !this.senhaGroup.pristine && this.confirmacao.value != null  ){
         alterouSenha = true;
         ob['INTERNAL'] = this.confirmacao.value; //Temos q implementar o cognito aqui tbm para quando ele mudar de senha ir pelo MFA e parar de salvar no servidor
      }

      let timeToExpire = 30;
      if ( ObjectUtil.isNotEmpty(this.uas.user.passexptimeout) ){
          timeToExpire = this.uas.user.passexptimeout;
      }
      
      let expiration = DateUtils.addDays(new Date(), timeToExpire);
      let expirationStr  = this.datepipe.transform(expiration, 'yyyy-MM-dd HH:mm:ss.SSS'); 
      ob['EXPIRATION'] = expirationStr;
      
      if(alterouSenha){
        this.uas.forcePassword(this.uas.user.username,  btoa (this.confirmacao.value), expirationStr, btoa(this.oldPass.value)).then(m=>{        
              this.saveInfoUser(ob);          
          }, r=>{
            this.isLoading = false;
            this.cd.detectChanges();
            throw r;
          }).catch(e=>{
            this.isLoading = false;
            this.cd.detectChanges();
            throw e;
          });
      
        
      }else{  
        this.saveInfoUser(ob);
        
      }
    }else{
      return;
    }
    
  }

  private saveInfoUser(ob: { entityName: string; LAYOUT: any; USERAVATAR: any; NOME: any; IDUSER: any; TIMEOUT: any; USETAB: any }) {
    this.sub = this.http.post(ob, 'JsonBrokerServices/save', false, true, true).subscribe(data => {
      this.uas.reloadUser().then(user => {

        // aplica o novo layout sem F5 (troca a moldura se necessário)
        this.layoutVersionService.refresh();
        this.snackBar.showSuccess("Configurações do usuário alterado.");
        this.dialogRef.close(this.dataNz);
        this.isLoading = false;
        this.cd.detectChanges();
      });

    }, error => {
      this.isLoading = false;
      this.cd.detectChanges();
      throw error;
    }, () => {
    });
  }

  loadData(){

      let ob = {
          entityName: 'Mktpuser',
          condition: `iduser = ${this.uas.user.iduser}`,
          rows: 1,
          showImageData: true,
          showImageDataBase64: true
      }
      this.isLoading = true;
      this.sub2 = this.http.post(ob,'JsonBrokerServices/find',false,true,true).subscribe(data=>{
          this.formGroup.get('username').patchValue(data['Mktpuser'][0]['USERNAME']);
          this.formGroup.get('iduser').patchValue(data['Mktpuser'][0]['IDUSER']);
          this.formGroup.get('nome').patchValue(data['Mktpuser'][0]['NOME']);
          this.formGroup.get('layout').patchValue(data['Mktpuser'][0]['LAYOUT']);
          this.formGroup.get('timeout').patchValue(data['Mktpuser'][0]['TIMEOUT']);
          this.formGroup.get('usetab').patchValue(data['Mktpuser'][0]['USETAB']);
          this.formGroup.get('iddashboard').patchValue({ key: data['Mktpuser'][0]['IDDASHBOARD'] });

          if ( ObjectUtil.isNotEmpty(data['Mktpuser'][0]['USERAVATAR'])){

              let objectURL = 'data:image/png;base64,' + data['Mktpuser'][0]['USERAVATAR'];
              this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
              this.formGroup.get('useravatar').patchValue(data['Mktpuser'][0]['USERAVATAR']);

          }else{
            this.image = this.sanitizer.bypassSecurityTrustUrl("assets/image/no-image-icon-round.png")
          }
          this.cd.detectChanges();
      },error=>{
          throw error;
      },()=>{
        this.isLoading = false;
        this.cd.detectChanges();
      });
  }

private upload() {  
    this.fileInput.nativeElement.value = '';  
    this.files.forEach(file => { 
      this.callUploadService(file,"Mktpuser","USERAVATAR",`iduser=${this.uas.user.iduser}`);  
    });  
}

callUploadService(file, entityName:string, columnName:string, condicao:string) {  
  
  const formData = new FormData();  
  formData.append('file', file.data, 'image');  
  
  let ob = {
      entityName: entityName,
      datafield: columnName,
      condition: condicao
  }
  
  let blob = new Blob([JSON.stringify(ob)], {
    type: 'application/json',
  });
  formData.append('data',JSON.stringify(ob));

  file.inProgress = true;  

  this.sub3 = this.uploadService.progress.subscribe(number=>{
    file.progress = number;
  })

  this.uploadService.upLoadFile(formData);
  
  
}

  onClick() {  
    this.files = [];
    const fileInput = this.fileInput.nativeElement;
    fileInput.onchange = () => {  
        for (let index = 0; index < fileInput.files.length; index++)  {  
             const file = fileInput.files[index];  
             this.files.push({ data: file, inProgress: false, progress: 0});  
        }  
          this.upload();  
    };  
    fileInput.click();  
  }


  
  get timeout() {
    return this.formGroup.get('timeout');
  }

  get nome() {
    return this.formGroup.get('nome');
  }

  get confirmacao() {
    return this.senhaGroup.get('confirmacao');
  }

  
  get password() {
    return this.senhaGroup.get('password');
  }

  get oldPass() {
    return this.senhaGroup.get('oldPassword');
  }

}
